export enum ModelsDisplayingModes {
  TABLE = 'table',
  GRID = 'grid',
  MAP = 'map',
}
